<template>
  <PrintPageLandscape>
    <PresentationPage :page-number="pageNumber" :page-count="pageCount">
      <p class="presentation-page__eyebrow">Leistungs-Portfolio · Photovoltaik</p>

      <h2 class="presentation-page__title">Was wir konkret leisten</h2>

      <p class="presentation-page__text">
        Fünf Säulen — von DC-Installation bis zur Wartung über 20 Jahre.
      </p>

      <div class="presentation-page__group-cards presentation-page__group-cards--five">
        <article
          v-for="pillar in pillars"
          :key="pillar.title"
          :class="[
            'presentation-page__group-card',
            `presentation-page__group-card--top-accent-${pillar.topAccent}`,
          ]"
        >
          <div class="presentation-page__group-card-body presentation-page__group-card-body--phase">
            <div
              :class="[
                'presentation-page__group-card-icon',
                `presentation-page__group-card-icon--${pillar.iconAccent}`,
              ]"
              aria-hidden="true"
            >
              <i :class="['fa', pillar.icon]"></i>
            </div>

            <h3 class="presentation-page__group-card-title">{{ pillar.title }}</h3>

            <div class="presentation-page__group-card-accent" aria-hidden="true"></div>

            <ul class="presentation-page__list">
              <li v-for="item in pillar.items" :key="item">{{ item }}</li>
            </ul>
          </div>
        </article>
      </div>
    </PresentationPage>
  </PrintPageLandscape>
</template>

<script>
import PrintPageLandscape from '@/components/Print/PrintPageLandscape.vue';
import PresentationPage from '@/views/MasterPresentation/PresentationPage';

export default {
  name: 'MasterPresentationPrintPage12',

  components: {
    PrintPageLandscape,
    PresentationPage,
  },

  props: {
    project: { type: Object, default: null },
    pageCount: { type: Number, default: null },
    pageNumber: { type: Number, default: 0 },
  },

  data() {
    return {
      pillars: [
        {
          topAccent: 'brand-primary',
          iconAccent: 'brand-primary',
          icon: 'fa-sun-o',
          title: 'DC-Installation',
          items: ['Montage Unterkonstruktion', 'Montage Solarmodule', 'Kabelverlegung'],
        },
        {
          topAccent: 'brand-primary',
          iconAccent: 'brand-primary',
          icon: 'fa-bolt',
          title: 'AC-Installation',
          items: [
            'Wechselrichter installieren',
            'Speicher installieren',
            'Netzanschluss',
            'Inbetriebnahme',
          ],
        },
        {
          topAccent: 'brand-teal',
          iconAccent: 'brand-teal',
          icon: 'fa-tachometer',
          title: 'Monitoring',
          items: ['Überwachungssystem', 'Datenlogger einrichten', 'Energiemanagementsystem'],
        },
        {
          topAccent: 'brand-primary',
          iconAccent: 'brand-primary',
          icon: 'fa-car',
          title: 'Elektromobilität',
          items: ['Wallbox / Ladesäule', 'Kommunikationsanbindung', 'Inbetriebnahme'],
        },
        {
          topAccent: 'brand-primary',
          iconAccent: 'brand-primary',
          icon: 'fa-wrench',
          title: 'Wartung',
          items: ['Jahres- & Halbjahreswartung', 'Fernüberwachung', 'Störungsbeseitigung'],
        },
      ],
    };
  },
};
</script>
